<template>
    <div>
        <PageHeader :title="pageHeader">
            <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="page-header-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </template>
        </PageHeader>

            <div class="grid grid-cols-3 gap-4">
                <div class="bg-white mt-2 p-4">
                    <div class="flex mb-2">
                        <h1 class="text-gray-600 font-semibold text-lg">Cliente:</h1>
                        <svg v-if="loadingCompanies" class="animate-spin ml-1 mt-1 mr-3 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                    <SimpleTypeahead
                        :disabled="loadingCompanies"
                        ref="typeaheadRef"
                        id="typeahead_id"
                        placeholder="Nome da Empresa"
                        :items="companies"
                        :itemProjection="company => company.title"
                        :minInputLength="1"
                        @selectItem="onSelectCompany"
                    ></SimpleTypeahead>
                </div>
            <div class="bg-white mt-2 p-4" v-if="selectedCompany && selectedManager">
                <div class="flex mb-2">
                    <h1 class="text-gray-600 font-semibold text-lg">Critérios Utilizados (Megaforms)</h1>
                    <svg v-if="loadingListForms" class="animate-spin ml-1 mt-1 mr-3 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <svg @click="activateShowFormField" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 text-green-600 cursor-pointer">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                    </svg>
                    </div>
                    <p class="text-xs text-gray-500 mb-2">{{ formContextLabel }}</p>
                    <div v-show="showFormField" class="flex gap-x-2">
                        <SimpleTypeahead
                            v-if="selectedCompany && selectedManager"
                            v-model="selectedFormTypeahead"
                            :disabled="loadingListForms"
                            ref="typeaheadRef2"
                            id="typeahead_id2"
                            placeholder="MegaForm"
                            :items="formOptions"
                            :itemProjection="form => form.title"
                            :minInputLength="1"
                            @selectItem="onSelectForm"
                        ></SimpleTypeahead>
                    </div>
                    <h1 class="text-green-600 font-bold text-xl">{{ form.name }}</h1>
                    <p v-if="selectedWorkerPDITarget && !selectedWorkerHasOwnForm && selectedManagerHasForm" class="text-xs text-gray-500 mt-1">
                        Usando o formulário padrão do gestor selecionado.
                    </p>
                </div>
                <div class="bg-white mt-2 p-4" v-if="selectedCompany && selectedManager">
                    <div class="flex items-center gap-2 mb-2">
                        <h1 class="text-gray-600 font-semibold text-lg">Formulários de Presença</h1>
                        <svg v-if="loadingPresenceLink" class="animate-spin h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                    <div class="flex gap-x-2">
                        <SimpleTypeahead
                            v-if="pdiForm && pdiForm.id"
                            v-model="selectedPresenceTypeahead"
                            :disabled="loadingPresenceLink || !presenceFormOptions.length"
                            ref="presenceTypeaheadRef"
                            id="presence_typeahead"
                            placeholder="Vincular formulário de presença"
                            :items="presenceFormOptions"
                            :itemProjection="form => form.title"
                            :minInputLength="0"
                            @selectItem="onLinkPresenceForm"
                        ></SimpleTypeahead>
                        <p v-else class="text-sm text-gray-500">Selecione um liderado para vincular formulários.</p>
                    </div>
                <div v-if="presenceDisplayList.length" class="flex flex-col gap-y-2 mt-4">
                    <div
                        v-for="presence in presenceDisplayList"
                        :key="presence.id"
                        class="flex items-center justify-between border border-gray-200 rounded-md px-3 py-2 cursor-pointer hover:bg-green-50 transition-colors"
                        @click="downloadPresenceReport(presence)"
                    >
                        <div class="flex items-center gap-3">
                            <span
                                class="inline-flex items-center justify-center w-6 h-6 rounded-full"
                                :class="presence.completed ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-500'"
                            >
                                <svg v-if="presence.completed" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v8m-4-4h8" />
                                    </svg>
                                </span>
                            <div class="flex flex-col">
                                <span class="text-sm font-semibold text-gray-700">{{ presence.name }}</span>
                                <span class="text-xs text-gray-500">
                                    {{ presence.completed ? 'Presença confirmada' : 'Sem presença registrada' }}
                                </span>
                                <span v-if="downloadingPresenceId === presence.id" class="text-xs text-green-600 mt-1">Gerando PDF...</span>
                            </div>
                        </div>
                        <button
                            class="text-red-500 hover:text-red-600"
                            type="button"
                            @click.stop="removePresenceForm(presence.id)"
                            :disabled="loadingPresenceLink || downloadingPresenceId === presence.id"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    </div>
                    <p v-else class="text-xs text-gray-500 mt-4">Nenhum formulário de presença vinculado.</p>
                </div>
            </div>

        <div v-if="loadingListManagers" class="bg-white p-4 mt-4 mb-4">
            <!-- Loading Skeleton-->
            <div class="mt-4 mx-auto w-full rounded-md p-4 mb-4">
                <div class="flex animate-pulse space-x-4">
                    <div class="size-10 rounded-full bg-gray-300"></div>
                    <div class="flex-1 space-y-6 py-1">
                    <div class="h-2 rounded bg-gray-300"></div>
                    <div class="space-y-3">
                        <div class="grid grid-cols-3 gap-4">
                        <div class="col-span-2 h-2 rounded bg-gray-300"></div>
                        <div class="col-span-1 h-2 rounded bg-gray-300"></div>
                        </div>
                        <div class="h-2 rounded bg-gray-300"></div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Gestores -->
        <div class="bg-white p-4 mt-4" v-if="selectedCompany && !loadingListManagers">
            <h1 class="text-lg font-bold text-gray-600 uppercase mt-2 -mb-4">Avaliadores</h1>
            <div class="flex items-center gap-3 mt-4 flex-wrap">
                            
                <!-- Diretor -->
                <div class="flex items-center gap-2">
                    <div class="w-3 h-3 rounded-sm bg-yellow-500"></div>
                    <span class="text-sm text-gray-600">CEO/Diretor</span>
                </div>

                <!-- Gerente -->
                <div class="flex items-center gap-2">
                    <div class="w-3 h-3 rounded-sm bg-blue-500"></div>
                    <span class="text-sm text-gray-600">Gerente/Coord</span>
                </div>
            </div>
            <div class="grid grid-cols-4 gap-2 mt-6 bg-white p-4">
                <div
                    v-for="manager in availableManagers"
                    :key="manager.id"
                    @click="onSelectManager(manager)"
                    :class="[
                        'bg-white border-2 p-2 flex justify-center items-center cursor-pointer hover:bg-gray-100 transition-all',
                        manager.role === 'director'
                            ? 'border-yellow-600 bg-yellow-100'
                            : manager.role === 'manager'
                            ? 'border-blue-500 bg-blue-100'
                            : 'border-green-600 bg-green-100',
                        selectedManager && manager.id !== selectedManager ? 'opacity-40' : ''
                    ]"
                >
                    <span class="text-sm font-bold text-gray-600">{{ manager.name }}</span>
                </div>
            </div>

        </div>

        <!-- Liderados -->
        <div class="bg-white p-4 mt-4" v-if="selectedManager && subordinates.length && form.uuid">
            <h1 class="text-lg font-bold text-gray-600 uppercase mt-2 -mb-4">Liderados</h1>
            <div class="grid grid-cols-4 gap-2 mt-6 bg-white p-4">
                <div
                    v-for="worker in subordinates"
                    :key="worker.id"
                    @click="onSelectCompetencePDITarget(worker)"
                    :class="[
                        'bg-white border-2 p-2 flex justify-center items-center cursor-pointer hover:bg-gray-100 transition-all',
                        worker.role === 'director'
                            ? 'border-yellow-600 bg-yellow-100'
                            : worker.role === 'manager'
                            ? 'border-blue-500 bg-blue-100'
                            : 'border-green-600 bg-green-100',
                        selectedWorkerPDITarget
                            ? worker.id === selectedWorkerPDITarget
                                ? 'opacity-100 ring-2 ring-green-600'
                                : 'opacity-40'
                            : 'opacity-100'
                    ]"
                >
                    <span class="text-xs font-bold text-gray-600">{{ worker.name }}</span>
                </div>
            </div>
        </div>

        <div v-if="selectedWorkerPDITarget" class="bg-white p-4 mt-4">
            <h1 class="text-lg font-bold text-gray-600 uppercase mt-2 -mb-4">Critérios</h1>
            <div class="flex flex-col mt-6">
                <label class="label">Data de Competência</label>
                <Datepicker class="w-3/12" :clearable="false" locale="pt-BR" monthPicker v-model="competenceDate" @update:modelValue="onChangeCompetenteDate()" autoApply />
            </div>
        </div>

        <div v-if="loadingPDIRendering" class="bg-white p-4">
            <!-- Loading Skeleton-->
            <div class="mt-4 mx-auto w-full rounded-md p-4 mb-4">
                <div class="flex animate-pulse space-x-4">
                    <div class="size-10 rounded-full bg-gray-300"></div>
                    <div class="flex-1 space-y-6 py-1">
                    <div class="h-2 rounded bg-gray-300"></div>
                    <div class="space-y-3">
                        <div class="grid grid-cols-3 gap-4">
                        <div class="col-span-2 h-2 rounded bg-gray-300"></div>
                        <div class="col-span-1 h-2 rounded bg-gray-300"></div>
                        </div>
                        <div class="h-2 rounded bg-gray-300"></div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- FORM e TERMOMETRO -->
        <div v-if="pdiForm && pdiForm.id" class="grid grid-cols-8 bg-white p-4">
            <div v-if="!loadingPDIRendering" class="col-span-6">
                <!-- FORM RENDER-->
                <div v-if="selectedWorkerPDITarget">

                    <div @click="destroyPDI(pdiForm.id)" class="flex gap-x-2 w-2/12 p-1 mb-2 cursor-pointer hover:bg-red-100">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-red-600 w-6 h-6 cursor-pointer">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                        </svg>
                        <span class="text-sm font-semibold mt-0.5">Excluir PDI</span>
                    </div>
                    <!-- LOOP Structure -->
                    <div v-for="field in pdiForm.form_structure.structure" :key="field.uuid">
                        
                        <!-- Columns-->
                        <div class="grid grid-cols-12">
                            <div class="col-span-8 flex p-1 bg-gray-50 mt-2">
                                
                                <div class="flex flex-col w-full">
                                    <div class="flex">
                                        <div class="text-sm font-bold mr-2 w-6 h-6 text-center text-white border border-gray-500 rounded-full bg-green-800 p-0.5">{{ field.points || 0 }}</div>
                                        <label :class="{ 'bg-pink-100': field.lock }" class="text-base font-light text-gray-900">{{ field.label }}</label>
                                    </div>
                                    
                                    <div v-if="field.type == 'long_text'" class="mt-2">
                                        <BaseTextarea class="w-full" rows="5" v-model="field.answer" @input="debouncedTextareaSave" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-4 flex gap-x-2 mt-2">
                                <div v-for="option in field.options" :key="option.uuid" class="flex items-center gap-x-1 bg-green-50">
                                    <BaseRadio
                                        :value="option.label"
                                        :label="option.label"
                                        :name="field.uuid"
                                        v-model="field.answer"
                                        @update:modelValue="onAnswerChange(field, option)"
                                    />
                                </div>
                            </div>
                        </div>

                    </div> <!-- End Loop -->
                </div>
            </div>
            <div v-if="!loadingPDIRendering" class="col-span-2">
                <!-- {{ pdiForm.form_structure.score_result }} -->
                <!-- TERMOMETRO -->
                <PdiScore
                    :structure="pdiForm.form_structure.structure"
                    :score_result="pdiForm.form_structure.score_result"
                    :competence_label="competenceLabel"
                    :show_bonus="hasWorkerBonusRules"
                    :bonus_amount="formattedPdiBonusAmount"
                    :bonus_rules="workerBonusRules"
                />
            </div>
        </div>

    </div>
</template>

<script>
    import { ref, onMounted, computed } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import Swal from 'sweetalert';
    import UtilService from '../services/UtilService';
    import { defaultDate } from '../filters/date';
    import SimpleTypeahead from 'vue3-simple-typeahead';
    import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
    import { FormService, CompanyService, WorkerService, PDIService } from '../services/Entity';
    import PdiScore from '../components/PdiScore.vue';
    import { DateTime } from 'luxon';
    import { toast } from 'vue3-toastify';
    import 'vue3-toastify/dist/index.css';

    export default {
        name: 'Forms',
        components: {
            SimpleTypeahead,
            PdiScore
        },
        setup() {
            const pageHeader = ref('Plano de Desenvolvimento Individual')
            const loading = ref(false);
            const companies = ref([]);
            const selectedCompany = ref();
            const selectedManager = ref();
            const selectedManagerData = ref(null);
            const subordinates = ref([]);
            const loadingCompanies = ref(false);
            const formOptions = ref([]);
            const presenceFormOptions = ref([]);
            const presenceFormsById = ref({});
            const modalRef = ref();
            const loadingForm = ref(false);
            const loadingListManagers = ref(false);
            const form = ref({});
            const typeaheadRef2 = ref();
            const presenceTypeaheadRef = ref();
            const availableManagers = ref([]);
            const now = new Date();
            const pdiForm = ref({});
            const competenceDate = ref({
                month: now.getMonth(), // porque JS é 0-based
                year: now.getFullYear()
            });
            const selectedWorkerPDITarget = ref();
            const loadingListForms = ref(false);
            const showFormField = ref(false);
            const selectedFormTypeahead = ref(null);
            const selectedPresenceTypeahead = ref(null);
            const loadingSubmitPDI = ref(false);
            const loadingPDIRendering = ref(false);
            const loadingPresenceLink = ref(false);
            const downloadingPresenceId = ref(null);
            const workerBonusRules = ref([]);
            const pdi = ref();
            const pdis = ref([
                { uuid: 1 },
                { uuid: 2 },
                { uuid: 3 }
            ]);
            const presenceDisplayList = computed(() => {
                const summary = pdiForm.value?.presence_summary;

                if (Array.isArray(summary) && summary.length) {
                    return summary;
                }

                const linkedIds = Array.isArray(pdiForm.value?.presence_forms)
                    ? pdiForm.value.presence_forms
                    : [];

                return linkedIds.map(id => {
                    const formData = presenceFormsById.value?.[id] || {};

                    return {
                        id,
                        uuid: formData.uuid,
                        name: formData.name || `Formulário ${id}`,
                        completed: false
                    };
                });
            });
            const selectedWorkerRecord = computed(() => (
                subordinates.value.find(worker => worker.id === selectedWorkerPDITarget.value) || null
            ));
            const selectedWorkerHasOwnForm = computed(() => Boolean(selectedWorkerRecord.value?.pdiform));
            const selectedManagerHasForm = computed(() => Boolean(selectedManagerData.value?.pdiform));
            const formContextLabel = computed(() => {
                if (selectedWorkerPDITarget.value) {
                    return 'Com um colaborador selecionado, a troca do Megaform afeta apenas esse colaborador.';
                }

                return 'Sem colaborador selecionado, o Megaform configurado vale como padrão do gestor.';
            });
            const pdiTotalScore = computed(() => {
                const structure = pdiForm.value?.form_structure?.structure || [];

                return structure.reduce((total, field) => {
                    const value = Number(field.answer);
                    return total + (Number.isNaN(value) ? 0 : value);
                }, 0);
            });
            const hasWorkerBonusRules = computed(() => Array.isArray(workerBonusRules.value) && workerBonusRules.value.length > 0);
            const matchedPdiBonusRule = computed(() => {
                if (!hasWorkerBonusRules.value) {
                    return null;
                }

                return workerBonusRules.value.find(rule => {
                    const scoreStart = Number(rule.score_start);
                    const scoreEnd = Number(rule.score_end);

                    if (Number.isNaN(scoreStart) || Number.isNaN(scoreEnd)) {
                        return false;
                    }

                    return pdiTotalScore.value >= scoreStart && pdiTotalScore.value <= scoreEnd;
                }) || null;
            });
            const pdiBonusAmount = computed(() => {
                if (!matchedPdiBonusRule.value) {
                    return 0;
                }

                const amount = Number(matchedPdiBonusRule.value.bonus_amount);
                return Number.isNaN(amount) ? 0 : amount;
            });
            const formattedPdiBonusAmount = computed(() => new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(pdiBonusAmount.value));
            const competenceLabel = computed(() => {
                if (!competenceDate.value || typeof competenceDate.value.month === 'undefined' || !competenceDate.value.year) {
                    return '';
                }

                const competence = DateTime.local(competenceDate.value.year, Number(competenceDate.value.month) + 1, 1)
                    .setLocale('pt-BR');
                const formatted = competence.toFormat('LLLL yyyy');

                return formatted.charAt(0).toUpperCase() + formatted.slice(1);
            });
            const pdiBonusDescription = computed(() => {
                if (!hasWorkerBonusRules.value) {
                    return '';
                }

                if (!matchedPdiBonusRule.value) {
                    return 'Nao existe faixa configurada para essa pontuacao nesta competencia.';
                }

                return `Faixa aplicada: ${matchedPdiBonusRule.value.score_start} a ${matchedPdiBonusRule.value.score_end} pontos.`;
            });

            function syncPresenceCatalog(summary = []) {
                if (!Array.isArray(summary) || !summary.length) {
                    return;
                }

                const current = { ...presenceFormsById.value };
                let changed = false;

                for (const item of summary) {
                    if (!item || !item.id) {
                        continue;
                    }

                    const existing = current[item.id];
                    if (!existing || existing.name !== item.name || existing.uuid !== item.uuid) {
                        current[item.id] = {
                            name: item.name,
                            uuid: item.uuid
                        };
                        changed = true;
                    }
                }

                if (changed) {
                    presenceFormsById.value = current;
                }
            }

            function applyPDIData(pdiData) {
                if (!pdiData) {
                    return;
                }

                const normalized = {
                    ...pdiData,
                    presence_forms: Array.isArray(pdiData.presence_forms) ? pdiData.presence_forms : [],
                    presence_summary: Array.isArray(pdiData.presence_summary) ? pdiData.presence_summary : []
                };

                pdiForm.value = normalized;
                syncPresenceCatalog(normalized.presence_summary);
                selectedPresenceTypeahead.value = null;
                downloadingPresenceId.value = null;
            }

            function getWorkerFormMeta(worker) {
                if (!worker?.pdiform) {
                    return null;
                }

                if (typeof worker.pdiform === 'object') {
                    return {
                        id: worker.pdiform.id,
                        uuid: worker.pdiform.uuid,
                        name: worker.pdiform.name
                    };
                }

                return null;
            }

            function getResolvedFormMeta(worker = null, manager = selectedManagerData.value) {
                return getWorkerFormMeta(worker) || getWorkerFormMeta(manager);
            }

            function findFormOptionByUuid(uuid) {
                if (!uuid) {
                    return null;
                }

                return formOptions.value.find(option => option.value === uuid) || null;
            }

            function updateSelectedManagerPDIForm(formData) {
                const normalizedForm = formData ? {
                    id: formData.id,
                    uuid: formData.uuid,
                    name: formData.name
                } : null;

                availableManagers.value = availableManagers.value.map(manager => (
                    manager.id === selectedManager.value
                        ? { ...manager, pdiform: normalizedForm }
                        : manager
                ));

                selectedManagerData.value = availableManagers.value.find(manager => manager.id === selectedManager.value) || null;
            }

            function updateSelectedWorkerPDIForm(formData) {
                const normalizedForm = formData ? {
                    id: formData.id,
                    uuid: formData.uuid,
                    name: formData.name
                } : null;

                subordinates.value = subordinates.value.map(worker => (
                    worker.id === selectedWorkerPDITarget.value
                        ? { ...worker, pdiform: normalizedForm }
                        : worker
                ));
            }

            async function syncDisplayedFormForContext(worker = selectedWorkerRecord.value) {
                const resolvedForm = getResolvedFormMeta(worker);

                if (!resolvedForm?.uuid) {
                    form.value = {};
                    selectedFormTypeahead.value = null;
                    showFormField.value = true;
                    return;
                }

                form.value = resolvedForm;
                selectedFormTypeahead.value = findFormOptionByUuid(resolvedForm.uuid) || {
                    title: resolvedForm.name,
                    value: resolvedForm.uuid
                };
                showFormField.value = false;
            }

            async function loadWorkerBonusRules(workerId = selectedWorkerPDITarget.value, companyId = selectedCompany.value, competence = competenceDate.value) {
                if (!workerId || !companyId || !competence) {
                    workerBonusRules.value = [];
                    return;
                }

                try {
                    const { data } = await WorkerService.getBonusRules(
                        workerId,
                        companyId,
                        competence.month,
                        competence.year
                    );

                    workerBonusRules.value = Array.isArray(data) ? data : [];
                } catch (err) {
                    workerBonusRules.value = [];
                    console.error('Erro ao carregar bonificacao do PDI:', err);
                }
            }

            onMounted(async () => {
               const allCompanies = await listCompanies();

                for (let company of allCompanies) {
                    companies.value.push({
                        title: company.name,
                        value: company.id
                    });
                }

                    const forms = await listForms();
                        
                    for (let item of forms) {
                        if (item.type === 'pdi') {
                            formOptions.value.push({
                                title: item.name,
                                value: item.uuid
                            });
                        }

                        if (item.type === 'presence') {
                            const option = {
                                title: item.name,
                                value: item.id,
                                uuid: item.uuid
                            };

                            presenceFormOptions.value.push(option);
                            presenceFormsById.value = {
                                ...presenceFormsById.value,
                                [item.id]: {
                                    name: item.name,
                                    uuid: item.uuid
                                }
                            };
                    }
                }
            });

            async function listForms(page = 1, limit = 100) {
                try {
                    loadingListForms.value = true;
                    const { data: { items } } = await FormService.list(page, limit);
                    loadingListForms.value = false;
                    
                    return items;
                } catch(err) {
                    loadingListForms.value = false;
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function listManagers() {
                try {
                    loadingListManagers.value = true;
                    const { data } = await WorkerService.getWorkersWithSubordinates(selectedCompany.value);
                    loadingListManagers.value = false;
                    
                    return data;
                } catch(err) {
                    loadingListManagers.value = false;
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function listCompanies(page = 1, limit = 9999) {
                try {
                    loadingCompanies.value = true;
                    const { data: { items } } = await CompanyService.list(page, limit, {});
                    loadingCompanies.value = false;

                    return items;
                } catch(err) {
                    loadingCompanies.value = false;
                    loading.value = false;
                    Swal({
                        title: 'Ocorreu um erro ao obter dados dos clientes',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function onSelectForm(selectedForm) {
                loadingListForms.value = true;
                form.value = await getFormByUUID(selectedForm.value);
                const targetWorkerId = selectedWorkerPDITarget.value || selectedManager.value;

                try {
                    await WorkerService.updatePDIForm(targetWorkerId, form.value.id);

                    if (selectedWorkerPDITarget.value) {
                        updateSelectedWorkerPDIForm(form.value);
                    } else {
                        updateSelectedManagerPDIForm(form.value);
                    }

                    showFormField.value = false;
                } finally {
                    loadingListForms.value = false;
                }
            }

            async function onLinkPresenceForm(selectedPresence) {
                if (!pdiForm.value?.id || !selectedPresence) {
                    return;
                }

                const formId = selectedPresence.value ?? selectedPresence.id;

                if (!formId) {
                    return;
                }

                const currentLinked = Array.isArray(pdiForm.value?.presence_forms)
                    ? [...pdiForm.value.presence_forms]
                    : [];

                if (currentLinked.includes(formId)) {
                    selectedPresenceTypeahead.value = null;
                    return;
                }

                try {
                    loadingPresenceLink.value = true;

                    const { data } = await PDIService.update(pdiForm.value.id, {
                        manager: selectedManager.value,
                        presence_forms: [...currentLinked, formId]
                    });

                    applyPDIData(data);
                    notify('Formulário de presença vinculado!');
                } catch (err) {
                    console.error('Erro ao vincular formulário de presença:', err);
                    Swal({
                        title: 'Não foi possível vincular',
                        text: 'Tente novamente em instantes.',
                        icon: 'error'
                    });
                } finally {
                    loadingPresenceLink.value = false;
                }
            }

            async function removePresenceForm(formId) {
                if (!pdiForm.value?.id) {
                    return;
                }

                const currentLinked = Array.isArray(pdiForm.value?.presence_forms)
                    ? [...pdiForm.value.presence_forms]
                    : [];

                const updatedLinked = currentLinked.filter(id => id !== formId);

                try {
                    loadingPresenceLink.value = true;

                    const { data } = await PDIService.update(pdiForm.value.id, {
                        manager: selectedManager.value,
                        presence_forms: updatedLinked
                    });

                    applyPDIData(data);
                    notify('Formulário de presença removido!');
                } catch (err) {
                    console.error('Erro ao remover formulário de presença:', err);
                    Swal({
                        title: 'Não foi possível remover',
                        text: 'Atualize a página e tente novamente.',
                        icon: 'error'
                    });
                } finally {
                    loadingPresenceLink.value = false;
                }
            }

            async function downloadPresenceReport(presence) {
                if (!presence?.id || !pdiForm.value?.id) {
                    return;
                }

                try {
                    downloadingPresenceId.value = presence.id;
                    const { data } = await PDIService.exportPresenceReport(pdiForm.value.id, presence.id);

                    if (data?.url) {
                        window.open(data.url, '_blank', 'noopener');
                    } else {
                        throw new Error('missing_url');
                    }
                } catch (err) {
                    console.error('Erro ao gerar PDF de presença:', err);
                    Swal({
                        title: 'Não foi possível gerar o PDF',
                        text: 'Tente novamente em instantes.',
                        icon: 'error'
                    });
                } finally {
                    downloadingPresenceId.value = null;
                }
            }

            async function getFormByUUID(uuid) {
                try {
                    loadingForm.value = true;
                    const { data } = await FormService.getById(uuid);
                    loadingForm.value = false;
                    
                    return data;
                } catch(err) {
                    loadingForm.value = false;
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function onSelectCompany(company) {
                if (!company || !company.value) {
                    return;
                }

                selectedCompany.value = company.value;
                selectedManager.value = null;
                selectedManagerData.value = null;
                selectedWorkerPDITarget.value = null;
                selectedFormTypeahead.value = null;
                form.value = {};
                pdiForm.value = {};
                availableManagers.value =  await listManagers(selectedCompany.value);
            }

            function addPDI() {
                resetPDI();
                setModalStatus('open');
            }

            function resetPDI() {
                pdi.value = {};
            }

            function setModalStatus(status) {
                modalRef.value.setModalStatus(status);
            }

            async function onSelectManager(manager) {
                selectedManager.value = manager.id;
                selectedManagerData.value = manager;
                selectedPresenceTypeahead.value = null;
                selectedWorkerPDITarget.value = null;
                pdiForm.value = {};
                workerBonusRules.value = [];
                subordinates.value = manager.subordinates;
                await syncDisplayedFormForContext(null);
            }

            async function onSelectCompetencePDITarget(selectedWorker) {
                selectedWorkerPDITarget.value = selectedWorker.id;
                await syncDisplayedFormForContext(selectedWorker);
                const selectedCompetence = {
                    month: competenceDate.value.month,
                    year: competenceDate.value.year
                };

                const payload = {
                    manager: selectedManager.value,
                    target: selectedWorkerPDITarget.value,
                    competence_month: selectedCompetence.month,
                    competence_year: selectedCompetence.year,
                    company: selectedCompany.value
                };

                loadingPDIRendering.value = true;
                try {
                    const { data } = await PDIService.findOrCreate(payload);
                    applyPDIData(data);
                    await loadWorkerBonusRules(selectedWorker.id, selectedCompany.value, selectedCompetence);
                } catch (err) {
                    console.error('Erro ao carregar PDI:', err);
                    if (err?.data?.error === 'pdi_form_not_configured') {
                        Swal({
                            title: 'Nenhum Megaform configurado',
                            text: 'Configure um formulário no gestor ou no colaborador selecionado antes de criar o PDI.',
                            icon: 'warning'
                        });
                        return;
                    }

                    Swal({
                        title: 'Não foi possível carregar o PDI',
                        text: 'Atualize a página e tente novamente.',
                        icon: 'error'
                    });
                } finally {
                    loadingPDIRendering.value = false;
                }
            }

            async function onChangeCompetenteDate() {
                const selectedCompetence = {
                    month: competenceDate.value.month,
                    year: competenceDate.value.year
                };
                const payload = {
                    manager: selectedManager.value,
                    target: selectedWorkerPDITarget.value,
                    competence_month: selectedCompetence.month,
                    competence_year: selectedCompetence.year,
                    company: selectedCompany.value
                };

                loadingPDIRendering.value = true;
                try {
                    const { data } = await PDIService.findOrCreate(payload);
                    applyPDIData(data);
                    await loadWorkerBonusRules(selectedWorkerPDITarget.value, selectedCompany.value, selectedCompetence);
                } catch (err) {
                    console.error('Erro ao atualizar competência do PDI:', err);
                    if (err?.data?.error === 'pdi_form_not_configured') {
                        Swal({
                            title: 'Nenhum Megaform configurado',
                            text: 'Configure um formulário no gestor ou no colaborador selecionado antes de criar o PDI.',
                            icon: 'warning'
                        });
                        return;
                    }

                    Swal({
                        title: 'Não foi possível atualizar',
                        text: 'Verifique os dados e tente novamente.',
                        icon: 'error'
                    });
                } finally {
                    loadingPDIRendering.value = false;
                }
            }

            function debounce(fn, delay) {
                let timeout;
                return function (...args) {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => fn.apply(this, args), delay);
                };
            }

            const debouncedTextareaSave = debounce(async function () {
                try {
                    await PDIService.update(pdiForm.value.id, {
                        manager: selectedManager.value,
                        form_structure: pdiForm.value.form_structure
                    });

                    notify('salvo!');
                } catch (err) {
                    console.error('Erro ao salvar:', err);
                }
            }, 1000);

            function activateShowFormField() {
                showFormField.value = true;
            }

            async function onAnswerChange(field, option) {
                try {
                    await PDIService.update(pdiForm.value.id, {
                        manager: selectedManager.value,
                        form_structure: pdiForm.value.form_structure
                    });

                    notify('salvo!');
                } catch(err) {
					console.log(err);
                }
            }

            function notify(notificationText) {
                toast(`${notificationText || ''}`, {
                    "theme": "colored",
                    "type": "success",
                    "dangerouslyHTMLString": true,
                    autoClose: 500
                });
            }

            async function destroyPDI(uuid) {
                try {
                    const confirm = await Swal({
                        title: 'Tem certeza que deseja excluir esse PDI?',
                        text: 'Esta ação não pode ser desfeita.',
                        icon: 'warning',
                        buttons: {
                            cancel: 'Cancelar',
                            confirm: {
                                text: 'Excluir',
                                className: 'swal-button--danger'
                            }
                        },
                        dangerMode: true
                    });

                    if (!confirm) return;

                    loadingPDIRendering.value = true;

                    const payload = {
                        target: selectedWorkerPDITarget.value,
                        competence_month: competenceDate.value.month,
                        competence_year: competenceDate.value.year,
                        company: selectedCompany.value,
                        id: pdiForm.value.id
                    };

                    await PDIService.destroy(payload);
                    await onChangeCompetenteDate();
                    notify('PDI excluído com sucesso!');

                    loadingPDIRendering.value = false;
                } catch (err) {
                    loadingPDIRendering.value = false;

                    if (err?.data?.error === 'not_allowed') {
                        Swal({
                            title: 'Você não tem permissão',
                            text: 'Apenas usuários autorizados podem excluir este PDI.',
                            icon: 'warning'
                        });
                        return;
                    }

                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente.',
                        icon: 'error'
                    });
                }
            }

            return {
                presenceDisplayList,
                presenceFormOptions,
                selectedPresenceTypeahead,
                presenceTypeaheadRef,
                loadingPresenceLink,
                downloadingPresenceId,
                formContextLabel,
                selectedWorkerHasOwnForm,
                selectedManagerHasForm,
                workerBonusRules,
                hasWorkerBonusRules,
                competenceLabel,
                formattedPdiBonusAmount,
                pdiBonusDescription,
                onLinkPresenceForm,
                removePresenceForm,
                downloadPresenceReport,
                loadingListManagers,
                destroyPDI,
                notify,
                onAnswerChange,
                debouncedTextareaSave,
                pdiForm,
                onChangeCompetenteDate,
                loadingPDIRendering,
                activateShowFormField,
                showFormField,
                selectedFormTypeahead,
                typeaheadRef2,
                form,
                onSelectCompetencePDITarget,
                competenceDate,
                selectedWorkerPDITarget,
                subordinates,
                selectedManager,
                onSelectManager,
                pdi,
                addPDI,
                setModalStatus,
                modalRef,
                loading,
                pageHeader,
                defaultDate,
                companies,
                selectedCompany,
                loadingCompanies,
                onSelectCompany,
                pdis,
                loadingSubmitPDI,
                loadingListForms,
                formOptions,
                loadingForm,
                onSelectForm,
                availableManagers
            }
        }
    }

</script>
